import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, getContext, withHandlers } from 'recompose'
import { orderedBlockIdsSelector } from '../../../../store/selectors/boardSelectors'
import {
  currentBlockIdSelector,
  embedModeSelector
} from '../../../../store/selectors/selectors'
import Shortcuts from '../../../../containers/Shortcuts'

export default compose(
  connect((state, { next }) => {
    const blockId = currentBlockIdSelector(state)
    const orderedBlockIds = orderedBlockIdsSelector(state)
    let target = orderedBlockIds.indexOf(blockId) + (next ? 1 : -1)

    // wrap
    if (target < 0) target = orderedBlockIds.length - 1
    else if (target >= orderedBlockIds.length) target = 0

    return {
      target: orderedBlockIds[target],
      embedMode: embedModeSelector(state)
    }
  }),
  getContext({ router: PropTypes.object }),
  withHandlers({
    onClick: ({ router, target, embedMode }) => event => {
      event.stopPropagation()
      const history = router.history
      let path = `../${target}`
      path += embedMode ? '.embed/' : '/'
      history.push(path)
    }
  }),
  Shortcuts('BLOCK', ({ next, onClick }) => (action, event) => {
    if (next && action === 'NEXT') onClick(event)
    if (!next && action === 'PREVIOUS') onClick(event)
  })
)
